import React, { useState } from 'react'
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Table,
  TableRow,
  TableCell,
  Button,
  IconButton,
  Collapse
} from '@material-ui/core'
import { map, replace, startCase, get, isEmpty, filter, sumBy, omit, findIndex, isEqual } from 'lodash'
import Loading from 'components/Loading'
import AdminDemographicsChart from 'admin/components/demographics/AdminDemographicsChart'
import DeleteIcon from '@material-ui/icons/Delete'

function VettingDemographicsTotal({ data, is_loading, filters }) {
  const [comparedData, setComparedData] = useState([])
  const existingIndex = findIndex(comparedData, (compData) => isEqual(compData.filters, filters))
  const filteredData = filter(data, filters)
  const totalPeople = sumBy(filteredData, 'number_of_people')
  const totalComparedPeople = sumBy(comparedData, 'totalPeople')
  const [showChart, setShowChart] = useState(false)

  const addToCompare = () => {
    const vettingLabel = 'beneficiary_vetting' in filters ? 'Beneficiary Vetting' : ''
    if (existingIndex !== -1) {
      alert('A similar comparison already exists.')
      return
    }
    setComparedData([
      ...comparedData,
      {
        filters,
        companyName: vettingLabel,
        totalPeople,
        data: filteredData
      }
    ])
  }

  const removeFromCompare = (index) => {
    const newData = [...comparedData]
    newData.splice(index, 1)
    setComparedData(newData)
  }

  const clearComparison = () => {
    setComparedData([])
  }

  const filtersArray = []

  if ('beneficiary_vetting' in filters) {
    filtersArray.push(
      <React.Fragment key="vetting">
        <TableCell style={{ width: '30%' }}>Beneficiary Vetting</TableCell>
        <TableCell>This vetting</TableCell>
      </React.Fragment>
    )
  }

  map(filters, (value, key) => {
    if (key !== 'beneficiary_vetting' && value) {
      const formattedKey = startCase(replace(key, /_/g, ' '))
      const formattedValue = startCase(replace(String(value), /_/g, ' '))
      filtersArray.push(
        <React.Fragment key={key}>
          <TableCell style={{ width: '30%' }}>{formattedKey}</TableCell>
          <TableCell>{formattedValue}</TableCell>
        </React.Fragment>
      )
    }
  })

  return (
    <div style={{ padding: 20, marginBottom: 10, background: '#546E7A' }}>
      <Grid container spacing={3} justifyContent="center" alignItems="center" alignContent="center">
        {data && (
          <Grid item xs={12}>
            <Card style={{ borderRadius: 8 }}>
              <CardContent>
                <Grid container spacing={3}>
                  {!isEmpty(filters) && filtersArray.length > 0 && (
                    <Grid item xs={12} md={6}>
                      <Typography style={{ color: '#455A64', textTransform: 'uppercase' }}>
                        <Table>
                          {map(filtersArray, (row, index) => (
                            <TableRow key={index}>{row}</TableRow>
                          ))}
                        </Table>
                      </Typography>
                      {existingIndex === -1 && (
                        <Button
                          onClick={addToCompare}
                          variant="contained"
                          size="small"
                          color="secondary"
                          style={{ marginTop: 20 }}
                        >
                          Add to Compare
                        </Button>
                      )}
                    </Grid>
                  )}
                  <Grid item xs={12} md={isEmpty(filters) || filtersArray.length === 0 ? 12 : 6}>
                    <Typography variant="h1" style={{ color: '#37474F', textAlign: 'center' }}>
                      {is_loading ? <Loading /> : totalPeople}
                    </Typography>
                    <Typography style={{ textAlign: 'center', fontSize: 24, color: '#607D8B' }}>
                      TOTAL
                    </Typography>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        )}
      </Grid>
      {comparedData.length > 0 && (
        <div>
          <Typography variant="h4" style={{ marginBottom: 20, color: '#F5F5F5' }}>
            Comparison Area
          </Typography>
          {comparedData.length > 1 && (
            <Button
              onClick={() => setShowChart((prev) => !prev)}
              variant="outlined"
              style={{ color: '#F5F5F5', borderColor: '#F5F5F5', marginBottom: 20 }}
            >
              {showChart ? 'Hide Chart' : 'Show Chart'}
            </Button>
          )}
          <Collapse in={showChart && comparedData.length > 1}>
            <div style={{ paddingBottom: 15 }}>
              <AdminDemographicsChart
                title="Demographics Comparison"
                subheader="Comparison of demographics based on filters"
                data={comparedData}
                total={totalComparedPeople}
              />
            </div>
          </Collapse>
          <Grid container spacing={3} alignContent="center">
            {comparedData.map((compData, index) => (
              <Grid item xs={12} lg={3} key={index} style={{ position: 'relative' }}>
                <Card variant="outlined" style={{ borderRadius: 8 }}>
                  <CardContent>
                    <Typography variant="h5" style={{ color: '#263238' }}>
                      {map(omit(compData.filters, ['company', 'beneficiary_vetting']), (value, key) =>
                        `${startCase(replace(String(value), /_/g, ' '))}`
                      ).join(', ')}
                    </Typography>
                    {compData.companyName && (
                      <Typography variant="body2">{compData.companyName}</Typography>
                    )}
                    <Typography style={{ fontSize: 24, color: '#455A64' }}>
                      {compData.totalPeople} People
                    </Typography>
                    <Typography style={{ fontSize: 18, color: '#546E7A' }}>
                      {((compData.totalPeople / totalComparedPeople) * 100).toFixed(2)}%
                    </Typography>
                  </CardContent>
                  <IconButton
                    onClick={() => removeFromCompare(index)}
                    style={{ color: 'red', position: 'absolute', top: 10, right: 10 }}
                  >
                    <DeleteIcon />
                  </IconButton>
                </Card>
              </Grid>
            ))}
          </Grid>
          {comparedData.length > 0 && (
            <Button
              onClick={clearComparison}
              variant="outlined"
              style={{ color: '#F5F5F5', borderColor: '#F5F5F5', marginTop: 15 }}
            >
              Reset Comparison
            </Button>
          )}
        </div>
      )}
    </div>
  )
}

export default VettingDemographicsTotal
